"use client";

import HeroPlaylistRow from "./HeroPlaylistRow";
import type { HighlightedGameSlide } from "./types";

type Props = {
  slides: HighlightedGameSlide[];
  selectedIndex: number;
  providerName: string;
  progress: number;
  onSelect: (index: number) => void;
};

const HeroPlaylist: FC<Props> = ({
  slides,
  selectedIndex,
  providerName,
  progress,
  onSelect,
}) => (
  <div className="relative hidden w-60 shrink-0 md:block">
    <ul className="absolute inset-0 flex flex-col gap-1.5 overflow-hidden">
      {slides.map((slide, index) => (
        <HeroPlaylistRow
          key={slide.id}
          slide={slide}
          providerName={providerName}
          isSelected={index === selectedIndex}
          progress={progress}
          onSelect={() => onSelect(index)}
        />
      ))}
    </ul>
  </div>
);

export default HeroPlaylist;
